import { render, staticRenderFns } from "./rompecabezas.vue?vue&type=template&id=f2d78fde"
import script from "./rompecabezas.vue?vue&type=script&lang=js"
export * from "./rompecabezas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports